import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import Spin from 'components/Spin';
import React, { memo, useMemo } from 'react';
import { FormattedNumber } from 'react-intl';
import { Link } from 'react-router-dom';
import { useElite } from 'v2/hooks/useElite';

import EliteProgressBar from './EliteProgressBar';

const useStyle = makeStyles(() => ({
  root: {
    height: '100%',
    borderRadius: 4,
  },
  title: {
    fontSize: 16.5,
    color: '#586375',
  },
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  gainsContainer: {
    marginTop: 16,

    '& .item': {
      marginBottom: 8,

      '& h2': {
        lineHeight: 1.2,
      },
    },
  },
  header: {
    marginBottom: 16,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  badge: {
    width: 50,
    height: 50,
  },
}));

const EliteCard = memo(() => {
  const classes = useStyle();
  const eliteListQuery = useElite();
  const { data, error } = eliteListQuery;

  const producerGains = useMemo(() => data?.gains_producer || 0, [data]);
  const affiliateGains = useMemo(() => data?.gains_affiliate || 0, [data]);
  const totalGains = useMemo(() => producerGains + affiliateGains, [affiliateGains, producerGains]);

  const isLoading = data === null && error == undefined;

  return (
    <Card elevation={1} square className={classes.root}>
      <CardContent className={classes.root}>
        {isLoading ? (
          <Spin />
        ) : (
          <div className={classes.container}>
            <div>
              <div className={classes.header}>
                <div>
                  <Typography color='inherit' component='h2' variant='h6'>
                    Elite
                  </Typography>
                  <Typography color='inherit' gutterBottom variant='subtitle1' component='span' style={{ margin: 0, fontSize: 12 }}>
                    Resumo de seus ganhos líquidos e faixa elite
                  </Typography>
                </div>

                <div>
                  {producerGains >= 100000 && data?.progress?.producer.current ? (
                    <img
                      className={classes.badge}
                      src={`/img/badges/${
                        data?.progress?.producer?.current?.has_plus
                          ? `${data.progress.producer.current.badge_elite}-plus.svg`
                          : `${data.progress.producer.current.badge_elite}.svg`
                      }`}
                      alt={`Badge ${data.progress.producer.current.name}`}
                    />
                  ) : null}
                </div>
              </div>

              <div>
                <EliteProgressBar producerGains={producerGains} />
              </div>

              <div className={classes.gainsContainer}>
                <div className='item'>
                  <Typography align='right' component='h2' className={classes.title}>
                    Ganhos como produtor / coprodutor
                  </Typography>
                  <Typography align='right' component='h2' variant='h5'>
                    <FormattedNumber value={producerGains} format='BRL' />
                  </Typography>
                </div>

                <div className='item'>
                  <Typography align='right' component='h2' className={classes.title}>
                    Ganhos como afiliado / coafiliado
                  </Typography>
                  <Typography align='right' component='h2' variant='h5'>
                    <FormattedNumber value={affiliateGains} format='BRL' />
                  </Typography>
                </div>

                <div className='item'>
                  <Typography align='right' component='h2' className={classes.title}>
                    Total de ganhos
                  </Typography>
                  <Typography align='right' component='h2' variant='h5'>
                    <FormattedNumber value={totalGains} format='BRL' />
                  </Typography>
                </div>
              </div>
            </div>

            <div>
              <Link to='/producer/elite'>Ver detalhes do programa elite</Link>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
});

export default EliteCard;
